import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { Text, TextFontSizes, TextFontWeights, TextLineHeights } from "@cinch-labs/design-system";
import styles from "./how-it-works.module.css";
import { Wrapper } from "@cinch-nx/shared-ui";
import HowItWorksStep from "./how-it-works-step";
import FinanceOfferIcon from "./assets/finance-offer.svg";
import FinanceApplyIcon from "./assets/finance-apply.svg";
import FinanceDecisionIcon from "./assets/finance-decision.svg";
import FinanceCalculatorIcon from "./assets/finance-calculator.svg";
import Link from "next/link";
function renderLink(text, path, classNames) {
    return /*#__PURE__*/ _jsx(Link, {
        href: path,
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/ _jsx("a", {
            className: styles.linkText,
            target: "_blank",
            rel: "noreferrer noopener",
            href: path,
            children: text
        })
    });
}
function HowItWorks({ i18n , className  }) {
    const [getAQuoteBeforeLink, getAQuoteAfterLink] = i18n.steps[0].splitText ?? [];
    return /*#__PURE__*/ _jsx("article", {
        className: cx(styles.howItWorks, className),
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    element: "h2",
                    fontSize: TextFontSizes["4xl"],
                    fontWeight: TextFontWeights.bold,
                    lineHeight: TextLineHeights.display,
                    className: styles.howItWorksMainTitle,
                    children: i18n.title
                }),
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: TextFontSizes.m,
                    fontWeight: TextFontWeights.book,
                    children: i18n.text
                }),
                /*#__PURE__*/ _jsxs("ol", {
                    className: styles.howItWorksSteps,
                    children: [
                        /*#__PURE__*/ _jsx(HowItWorksStep, {
                            i18n: i18n.steps[0],
                            Image: FinanceCalculatorIcon,
                            children: /*#__PURE__*/ _jsxs(Text, {
                                fontSize: TextFontSizes.m,
                                fontWeight: TextFontWeights.book,
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        "data-testid": "get-a-quote-before-text",
                                        children: getAQuoteBeforeLink
                                    }),
                                    renderLink("HP", "/car-finance/hire-purchase"),
                                    " or",
                                    " ",
                                    renderLink("PCP", "/car-finance/personal-contract-purchase"),
                                    /*#__PURE__*/ _jsx("span", {
                                        "data-testid": "get-a-quote-after-text",
                                        children: getAQuoteAfterLink
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(HowItWorksStep, {
                            i18n: i18n.steps[1],
                            Image: FinanceApplyIcon
                        }),
                        /*#__PURE__*/ _jsx(HowItWorksStep, {
                            i18n: i18n.steps[2],
                            Image: FinanceDecisionIcon
                        }),
                        /*#__PURE__*/ _jsx(HowItWorksStep, {
                            i18n: i18n.steps[3],
                            Image: FinanceOfferIcon
                        })
                    ]
                })
            ]
        })
    });
}
export default HowItWorks;
